<template>
    <!--<div>-->

        <el-dialog
                :visible.sync="lineshow"
                ref="dialog"
                width="54%"
                center>
            <div slot="footer" class="dialog-footer" style="margin-top: -40px;">
                <div id="drawLine" style="width: 750px;height:300px;"></div>
            </div>
        </el-dialog>
</template>

<script>
    let echarts = require('echarts/lib/echarts');
    require('echarts/lib/chart/bar');
    require('echarts/lib/chart/line');
    require('echarts/lib/component/tooltip');
    import apis from "@/config/apis";
    export default {
        data() {
            return {
                dialogShow: false,
                chart: null,
                lineshow: false,
                loading: false,
                id: ""
            };
        },
        methods: {
            close() {
                this.lineshow = false;
            },
            show(row) {
                this.lineshow = true;
                this.id = row.hard_number;
                this.drawLine();
            },

            drawLine() {
                this.loading = true;
                this.chart = echarts.init(document.getElementById("drawLine"));
                let params = {
                    hard_number:this.id
                }
                this.$axios.get(apis.getwsd, {params}).then(data => {
                        if (data.data.code == 200) {
                            let trending = data.data.data;
                            if (trending.length == 0) {
                                this.lineshow = false;
                                this.$message({
                                    type: "success",
                                    message: "无温湿度异常"
                                });
                            }
                            let humidityArr = [];
                            let temperatureArr = [];
                            let timeArr = [];
                            for (let obj in trending) {
                                humidityArr.push(trending[obj].humidity);
                                temperatureArr.push(trending[obj].temperature);
                                timeArr.push(trending[obj].time);
                                this.humidityValue = humidityArr;
                                this.temperatureValue = temperatureArr;
                                this.timeValue = timeArr;
                                this.loading = false;
                                var colors = ["#5793f3", "#d14a61", "#675bba"];
                                this.chart.setOption({
                                    color: colors,
                                    tooltip: {
                                        trigger: "none",
                                        axisPointer: {
                                            type: "cross"
                                        }
                                    },
                                    legend: {
                                        data: ["温度", "湿度"]
                                    },
                                    grid: {
                                        top: 70,
                                        bottom: 50
                                    },
                                    xAxis: [
                                        {
                                            type: "category",
                                            axisTick: {
                                                alignWithLabel: true
                                            },
                                            axisLine: {
                                                onZero: false,
                                                lineStyle: {
                                                    color: colors[1]
                                                }
                                            },
                                            axisPointer: {
                                                label: {
                                                    formatter: function(params) {
                                                        return (
                                                            "温度  " +
                                                            // params.value +
                                                            (params.seriesData.length
                                                                ? "：" + params.seriesData[0].data + "°C"
                                                                : "")
                                                        );
                                                    }
                                                }
                                            },
                                            // data: this.timeValue
                                            data:this.temperatureValue
                                        },
                                        {
                                            type: "category",
                                            axisTick: {
                                                alignWithLabel: true
                                            },
                                            axisLine: {
                                                onZero: false,
                                                lineStyle: {
                                                    color: colors[0]
                                                }
                                            },
                                            axisPointer: {
                                                label: {
                                                    formatter: function(params) {
                                                        return (
                                                            "湿度  " +
                                                            // params.value +
                                                            (params.seriesData.length
                                                                ? "：" + params.seriesData[0].data + "%"
                                                                : "")
                                                        );
                                                    }
                                                }
                                            },
                                            // data: this.timeValue
                                            data:this.humidityValue
                                        }
                                    ],
                                    yAxis: [
                                        {
                                            type: "value"
                                        }
                                    ],
                                    series: [
                                        {
                                            name: "湿度",
                                            type: "line",
                                            xAxisIndex: 1,
                                            smooth: true,
                                            data: this.humidityValue
                                        },
                                        {
                                            name: "温度",
                                            type: "line",
                                            smooth: true,
                                            data: this.temperatureValue
                                        }
                                    ]
                                });
                            }
                        }
                    });
            }
        },
        mounted() {
            this.$nextTick(() => {
                this.chart = echarts.init(document.getElementById("drawLine"));
                window.addEventListener("resize", this.chart.resize, false);
            });
        },
        destroyed() {
            window.removeEventListener("resize", this.chart.resize, false);
        }
    };
</script>

<style lang="scss" scoped>
    .Econtainer {
        z-index: 0;
        position: fixed;
        width: 750px;
        height: 300px;
        left: 30%;
        top: 20%;
        float: right;
        border-radius: 4px;

        .pclose {
            float: right;
            margin-top: 0;
            z-index: 999;

            .el-icon-error {
                font-size: 25px;
                margin-top: -8px;
                cursor: pointer;
            }
        }

        .Cspan {
            float: right;
            margin-top: 1%;
            z-index: 509;
            position: absolute;
        }
        .div{
            #drawLine {
                width: 750px;
                height: 300px;
                z-index: 0;
                background: rgba(155, 216, 236, 0.95);
                border-radius: 8px;
            }

        }


    }
</style>
